import InstagramIcon from './instagram-icon';
import styles from './instagram-section.module.css';

export interface InstagramPost {
  id: string;
  url: string;         // link to the individual Instagram post
  imageUrl?: string;   // optional – leave blank for placeholder card
  caption?: string;    // short caption shown on hover
}

const InstagramCard = ({ post }: { post: InstagramPost }) => {
  const handleClick = () => {
    try {
      window.analytics?.trackEvent('instagram_post_click', {
        post_id: post.id,
        post_url: post.url,
        post_caption: post.caption || '',
        page_section: 'instagram_section',
      });
    } catch { }
  };

  return (
    <a
      key={post.id}
      href={post.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.card}
      aria-label={post.caption || 'View Instagram post'}
      onClick={handleClick}
    >
      <div className={styles.cardImageWrap}>
        {post.imageUrl ? (
          <img
            src={post.imageUrl}
            alt={post.caption || 'Instagram post'}
            className={styles.cardImage}
            loading="lazy"
          />
        ) : (
          <div className={styles.cardPlaceholder}>
            <InstagramIcon />
          </div>
        )}

        {/* Hover overlay */}
        <div className={styles.cardOverlay}>
          {post.caption && (
            <span className={styles.overlayCaption}>{post.caption}</span>
          )}
          <InstagramIcon className={styles.overlayIcon} />
        </div>
      </div>
    </a>
  );
};

export default InstagramCard;